import React from 'react';
import { PricingTable } from '@clerk/clerk-react';
import { Box, Container, Typography, GlobalStyles } from '@mui/material'; // Ensure GlobalStyles is imported

const SubscriptionPage = () => {
  // IMPORTANT: Replace with your actual Pricing Table ID from the Clerk Dashboard
  const pricingTableId = process.env.REACT_APP_CLERK_PRICING_TABLE_ID || 'YOUR_PRICING_TABLE_ID_PLACEHOLDER';
  // IMPORTANT: Ensure your Clerk Publishable Key is correctly set in your environment variables
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

  if (!publishableKey) {
    console.error('Clerk publishable key is not defined. Please set REACT_APP_CLERK_PUBLISHABLE_KEY.');
    return (
      <Container>
        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <Typography variant="h5" color="error">
            Configuration Error
          </Typography>
          <Typography variant="body1">
            The subscription service is currently unavailable due to a configuration issue.
            Please contact support.
          </Typography>
        </Box>
      </Container>
    );
  }

  if (pricingTableId === 'YOUR_PRICING_TABLE_ID_PLACEHOLDER' && process.env.NODE_ENV !== 'test') {
    console.warn('Clerk Pricing Table ID is not configured. Please set REACT_APP_CLERK_PRICING_TABLE_ID or update the default in SubscriptionPage.js. Using placeholder ID.');
    // Clerk's <PricingTable /> will likely show an error or a default state if the ID is invalid.
  }

  return (
    <>
      <GlobalStyles
        styles={{
          '.cl-drawerRoot': {
            position: 'relative',
            isolation: 'isolate', // Creates a new stacking context
            zIndex: 99,
          },
        }}
      />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: 3 }}>
          Choose Your Plan
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <PricingTable forOrganizations={true} pricingTableId={pricingTableId} publishableKey={publishableKey} sx={{ position: 'relative', zIndex: 1 }} />
        </Box>
      </Container>
    </>
  );
};

export default SubscriptionPage;
